import { PROCESS_STATE_CAPTIONS, ProcessState } from 'domain/gpo/cockpit/instance/processInstanceService';
import { Badge } from 'framework/ui/mui-builder';
import { BadgeLayoutProps } from 'framework/ui/uiContract';

const COLORS: Record<ProcessState, BadgeLayoutProps['color']> = {
  [ProcessState.ACTIVE]: 'success',
  [ProcessState.COMPLETED]: 'primary',
  [ProcessState.EXTERNALLY_TERMINATED]: 'warning',
  [ProcessState.INTERNALLY_TERMINATED]: 'warning',
  [ProcessState.SUSPENDED]: 'secondary',
};

const ProcessStateBadge = ({ state }: { state: ProcessState }) => {
  const color = COLORS[state];
  const caption = PROCESS_STATE_CAPTIONS[state];
  return (
    <Badge color={color} sx={{ ml: 1 }}>
      {caption}
    </Badge>
  );
};

export default ProcessStateBadge;
